import React, { useEffect } from 'react';
import { FaCheck, FaClock, FaTimes } from 'react-icons/fa';
import { formatTaipeiDate } from './cardTime';

function PointDetailModal({ selected, merchantName, onClose, onConfirm }) {
  useEffect(() => {
    if (!selected) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    document.body.classList.add('card-modal-open');
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.classList.remove('card-modal-open');
    };
  }, [selected, onClose]);

  if (!selected) return null;

  const isAvailable = selected.state === 'available';
  const isPending = selected.state === 'pending';

  return (
    <div className="card-modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        className="card-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="point-modal-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button type="button" className="card-modal__close" onClick={onClose} aria-label="關閉">
          <FaTimes />
        </button>
        <div className={`card-modal__status card-modal__status--${selected.state}`}>
          {isAvailable ? <span>{selected.number}</span> : isPending ? <FaClock /> : <FaCheck />}
        </div>
        <p className="card-modal__eyebrow">會員集點卡</p>
        <h2 id="point-modal-title">
          {isAvailable ? '確認申請本次集點？' : isPending ? `第 ${selected.number} 點審核中` : `第 ${selected.number} 點已完成`}
        </h2>
        <dl className="card-modal__details">
          <div><dt>商戶</dt><dd>{merchantName}</dd></div>
          <div><dt>日期</dt><dd>{formatTaipeiDate(new Date())}</dd></div>
          <div><dt>狀態</dt><dd>{isAvailable ? '可以申請' : isPending ? '等待審核' : '已完成'}</dd></div>
        </dl>
        {isAvailable ? (
          <>
            <p className="card-modal__note">送出後將由專員審核，審核期間無法申請下一點。</p>
            <button type="button" className="card-modal__primary" onClick={() => onConfirm(selected.number)}>
              確認申請
            </button>
          </>
        ) : (
          <button type="button" className="card-modal__secondary" onClick={onClose}>我知道了</button>
        )}
      </section>
    </div>
  );
}

export default PointDetailModal;
